import React from 'react';
import { useParams } from 'react-router-dom';
import './ChatWindow.css';
import MessageList from './MessageList';
import MessageInput from './MessageInput';
import TypingIndicator from './TypingIndicator';
import { useChat } from '../hooks/useChat';
import { useMobileViewportFix } from '../hooks/useMobileViewportFix';

function ChatWindow() {
  // Get the chat ID from the URL
  const { id } = useParams<{ id?: string }>();
  
  // Use our custom hooks
  const { messages, sendMessage, isLoading, error } = useChat({ 
    chatId: id,
    maxMessages: 10
  });

  // Apply mobile viewport fixes using the custom hook
  useMobileViewportFix();

  return (
    <div className="chat-container">
      {error && (
        <div className="error-message" role="alert" aria-live="assertive">
          {error}
        </div>
      )}
      
      <MessageList messages={messages} />
      
      {isLoading && <TypingIndicator />}
      
      <MessageInput 
        onSendMessage={sendMessage}
        disabled={isLoading} 
      />
    </div>
  );
}

export default ChatWindow;
